import { render } from "./ReelPage.vue?vue&type=template&id=20dc116c"
import script from "./ReelPage.vue?vue&type=script&lang=js"
export * from "./ReelPage.vue?vue&type=script&lang=js"

import "./ReelPage.vue?vue&type=style&index=0&id=20dc116c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__